// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/dehydration-and-heatstroke.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/dehydration-and-heatstroke/dehydration-and-heatstroke.js';

mount([g0]);
